import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/shared/models/user.model';
import { NbTagComponent } from '@nebular/theme';
import { UserService } from 'src/app/shared/service/user.service';

@Component({
  selector: 'app-user-picker',
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.scss']
})
export class UserPickerComponent implements OnInit {
  @Input() cacheKey!: string;
  @Input() single = false;
  @Output() remove = new EventEmitter<User[]>();
  @Output() add = new EventEmitter<User[]>();

  selectedUsers: User[] = [];
  filterUsersByEmail$!: Observable<User[]>;
  filterUsersByPhone$!: Observable<User[]>;
  filterUsersByName$!: Observable<User[]>;
  filterUsersByCreditCard$!: Observable<User[]>;
  filterUsersByID$!: Observable<User[]>;
  filterUsersByNationalID$!: Observable<User[]>;
  filterUsersByIban$!: Observable<User[]>;
  emailQuery!: string;
  nameQuery!: string;
  phoneQuery!: string;
  creditCardQuery!: string;
  ibanQuery!: string;
  nationalIdQuery!: string;
  userIdQuery!: string;

  constructor(private userService: UserService) {}

  filter(query: any, type: string): void {
    const filter: any = {
      limit: 100
    };
    if (type === 'email' && typeof query === 'string') {
      filter.email = query;
      this.filterUsersByEmail$ = this.userService.getUserList(filter);
    }
    if (type === 'phone' && typeof query === 'string') {
      filter.phone = query;
      this.filterUsersByPhone$ = this.userService.getUserList(filter);
    }
    if (type === 'userID' && typeof query === 'string') {
      filter.id = query;
      this.filterUsersByID$ = this.userService.getUserList(filter);
    }
    if (type === 'nationalID' && typeof query === 'string') {
      filter.national_id = query;
      this.filterUsersByPhone$ = this.userService.getUserList(filter);
    }
    if (type === 'iban' && typeof query === 'string') {
      filter.iban = query;
      this.filterUsersByIban$ = this.userService.getUserListByIban(filter);
    }
    if (type === 'card' && typeof query === 'string') {
      filter.card = query;
      this.filterUsersByCreditCard$ = this.userService.getUserListByCreditCard(filter);
      this.filterUsersByCreditCard$.subscribe(console.log);
    }
    if (type === 'name' && typeof query === 'string') {
      const split = query.split(' ');
      filter.first_name = split[0];
      if (split[1]) {
        filter.last_name = split[1];
      }
      this.filterUsersByName$ = this.userService.getUserList(filter);
    }
  }

  viewHandleEmail(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }

  viewHandleUserID(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }

  viewHandleNationalID(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }

  viewHandlePhone(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }


  cacheUsers(): void {
    if (this.cacheKey) {
      localStorage.setItem(this.cacheKey, JSON.stringify(this.selectedUsers));
    }
  }

  viewHandleName(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }

  onTagRemove(tag: NbTagComponent): void {
    this.selectedUsers = this.selectedUsers.filter(
      (user) => user.id !== +tag._hostElement.nativeElement.getAttribute('data-delete')
    );
    this.remove.emit(this.selectedUsers);
    this.cacheUsers();
  }

  getCachedUsers(): void {
    if (this.cacheKey) {
      const rawUsers: any[] = JSON.parse(localStorage.getItem(this.cacheKey) ?? '[]');
      this.selectedUsers = rawUsers.map((user) => new User(user));
      this.add.emit(this.selectedUsers);
    }
  }

  ngOnInit(): void {
    this.filterUsersByEmail$ = of([]);
    this.filterUsersByName$ = of([]);
    this.getCachedUsers();
  }
}
